import { STORAGE_KEYS as o } from "./storage-manager.js";
import u from "./subscription-manager.js";
import Kt from "../models/server-config.js";
import s from "../common/event-logger.js";
import r from "../../shared-lib/braze-shared-lib.js";
export default class Mt {
  constructor(t) {
    (this.h = t),
      (this.tl = new u()),
      (this.el = new u()),
      (this.sl = new u()),
      (this.il = null);
  }
  rl() {
    if (null == this.il) {
      const t = this.h.I(o.q.hl);
      this.il = null != t ? Kt.Pn(t) : new Kt();
    }
    return this.il;
  }
  Zs() {
    return this.rl().ol;
  }
  al(t) {
    if (null != t && null != t.config) {
      const e = t.config;
      if (e.time > this.rl().ol) {
        const t = new Kt(
          e.time,
          e.events_blacklist,
          e.attributes_blacklist,
          e.purchases_blacklist,
          e.messaging_session_timeout,
          e.vapid_public_key,
          e.content_cards,
          e.feature_flags
        );
        let s = !1;
        null != t.gl && this.mn() !== t.gl && (s = !0);
        let i = !1;
        null != t.ml.enabled && this.Ys() !== t.ml.enabled && (i = !0);
        let r = !1;
        null != t.hi.enabled && this.ci() !== t.hi.enabled && (r = !0),
          (this.il = t),
          this.h.B(o.q.hl, t.ss()),
          s && this.tl.St(),
          i && this.el.St(),
          r && this.sl.St();
      }
    }
  }
  gn(t) {
    let e = this.tl.ut(t);
    return this.cl && this.tl.removeSubscription(this.cl), (this.cl = e), e;
  }
  Ms(t) {
    return this.el.ut(t);
  }
  Fi(t) {
    return this.sl.ut(t);
  }
  ge(t) {
    return -1 !== this.rl().fl.indexOf(t);
  }
  hu(t) {
    return -1 !== this.rl().bl.indexOf(t);
  }
  Dr(t) {
    return -1 !== this.rl().dl.indexOf(t);
  }
  vl() {
    return this.rl().wl;
  }
  mn() {
    return this.rl().gl;
  }
  Ys() {
    return this.rl().ml.enabled || !1;
  }
  ci() {
    return this.rl().hi.enabled && null == this.ji()
      ? (s.G(r.A.qs, { e: "Missing feature flag refresh_rate_limit." }), !1)
      : this.rl().hi.enabled || !1;
  }
  ji() {
    return this.rl().hi.refresh_rate_limit;
  }
}
